// News articles data for the "In the News" page
// This can be easily updated with new articles as they come in

export const newsArticles = [
  {
    id: 'tokyo-meets-port-vila-kakigori-2026',
    title: 'When Tokyo Met Port Vila: Kakigori, Rum, and the Spirit of Finding a Way',
    publication: '83 Islands Distillery',
    date: 'May 2026',
    excerpt: 'On 19 May, 83 Islands Distillery welcomed Mr. Yoshinori Nishigaya of Vinefru Ginza in Tokyo for a very special kakigori tasting in Port Vila. Around 30 guests discovered Japanese-style shaved ice — and how naturally it pairs with island ingredients and 83 Islands rum. Kakigori is coming to 83 Islands: island style, rum optional, experience guaranteed.',
    image: '/image/articles/kakigori-rum-finish.jpg',
    url: '/article/tokyo-meets-port-vila-kakigori',
    category: 'Industry',
    isInternal: true
  },
  {
    id: 'vinefru-kakigori-2026',
    title: 'Tokyo\'s Famous Kakigori Shaved Ice Comes to 83 Islands Distillery for One Day Only',
    publication: '83 Islands Distillery',
    date: 'May 2026',
    excerpt: '83 Islands Distillery welcomes Vinefru Ginza, one of Tokyo\'s most talked-about kakigori shaved ice shops, for a one-day event on May 19, 2026. Guests in Port Vila will have a rare opportunity to experience a celebrated Japanese food tradition, with a workshop for local bars and restaurants alongside the public event.',
    image: '/image/articles/vinefru-kakigori-event.png',
    url: '/article/vinefru-kakigori',
    category: 'Press Release',
    isInternal: true
  },
  {
    id: 'hiring-assistant-distiller-2026',
    title: 'We\'re Hiring: Assistant Distiller / Lab Assistant',
    publication: '83 Islands Distillery',
    date: 'March 2026',
    excerpt: 'We\'re hiring! 83 Islands Distillery is looking for an Assistant Distiller / Lab Assistant to join our production and laboratory team in Stella Mare, Efate. Full-time position — apply before 31 March 2026.',
    image: '/image/83islands_location.jpg',
    url: '/jobs#assistant-distiller-lab-assistant',
    category: 'Community',
    isInternal: true
  },
  {
    id: 'faea-kava-relaunch-2024',
    title: 'World First: 83 Islands Distillery Launches Faea Kava Spiced Rum',
    publication: '83 Islands Distillery',
    date: 'December 2025',
    excerpt: 'Vanuatu\'s 83 Islands Distillery unveils a world-first spirit combining noble kava and chilli with aged rum. After years of perfecting water-based kava extraction, this groundbreaking release showcases Vanuatu\'s most distinctive ingredients in one unforgettable spirit.',
    image: '/image/83islands-faeakava.jpg',
    url: '/article/faea-kava-relaunch',
    category: 'Press Release',
    isInternal: true
  },
  {
    id: 'wellington-taste-of-vanuatu',
    title: '83 Islands Distillery Showcases the Tastes of Vanuatu in Wellington',
    publication: '83 Islands Distillery',
    date: 'November 2025',
    excerpt: 'The Vanuatu High Commission in Wellington hosted a landmark event showcasing the Tastes of Vanuatu, featuring premium rum from 83 Islands Distillery and fine Vanuatu chocolate. The event marked the first official presentation of Vanuatu\'s rum and chocolate in New Zealand.',
    image: '/image/articles/wellington-diaspora-community.jpg',
    url: '/article/wellington-taste-of-vanuatu',
    category: 'Industry',
    isInternal: true
  },
  {
    id: 'gourmet-traveller-october-2025',
    title: "A local's guide to Vanuatu - Sip local spirits at 83 Islands Distillery",
    publication: 'Gourmet Traveller',
    date: 'October 2025',
    excerpt: 'For a taste of local craft spirits, 83 Islands Distillery transforms Vanuatu\'s abundant sugarcane into small-batch rum. The bar\'s polished wood and industrial feel bring a cool urban edge, where tasting flights reveal the nuanced complexity of cane spirits.',
    image: '/image/83islands_shop.jpg',
    url: 'https://www.gourmettraveller.com.au/travel/destinations/local-guide-vanuatu-things-to-do/',
    category: 'Travel'
  },
  {
    id: 'meandering-minimalists-august-2024',
    title: "We Drink 83 Islands' Worth of Alcohol (Mostly Rum)!",
    publication: 'Meandering Minimalists',
    date: 'August 2024',
    excerpt: 'On Vanuatu\'s main island, Efate, there\'s a distillery, cleverly named 83 Islands Distillery (after the 83 islands that make up the archipelago). The place is stunning, and everyone there was as friendly as we have now come to expect from the Ni-Vanuatu.',
    image: '/image/productionfloor.jpg',
    url: 'https://meanderingminimalists.com/83-islands/',
    category: 'Travel'
  },
  {
    id: 'london-spirits-competition-2023-Silver-2',
    title: 'London Spirits Competition 2023 - Silver Medal Winner',
    publication: 'London Spirits Competition',
    date: '2023',
    excerpt: '83 Islands Distillery receives Silver Medal recognition at the prestigious London Spirits Competition, showcasing the exceptional quality of our Vanuatu rum on the international stage.',
    image: '/image/83islands_location.jpg',
    url: 'https://londonspiritscompetition.com/en/winner-brands/spirits/2023/83-islands-distillery-3539/83-islands-distillery-7307.htm',
    category: 'Awards'
  },
  {
    id: 'london-spirits-competition-2023-silver',
    title: 'London Spirits Competition 2023 - Silver Medal Winner',
    publication: 'London Spirits Competition',
    date: '2023',
    excerpt: 'Additional Silver Medal recognition at the London Spirits Competition, further establishing 83 Islands Distillery as a producer of world-class rum from the Pacific.',
    image: '/image/83islands_location.jpg',
    url: 'https://londonspiritscompetition.com/en/winner-brands/spirits/2023/83-islands-distillery-3539/83-islands-distillery-7421.htm',
    category: 'Awards'
  },
  {
    id: 'curiada-dead-reckoning',
    title: 'Dead Reckoning 83 Islands Vanuatu Rum FRS',
    publication: 'Curiada',
    date: '2024',
    excerpt: 'Premium rum retailer Curiada features our Dead Reckoning collaboration, showcasing the unique character of Vanuatu rum to discerning spirits enthusiasts worldwide.',
    image: '/image/83islands_location.jpg',
    url: 'https://curiada.com/products/dead-reckoning-83-islands-vanuatu-rum-frs?srsltid=AfmBOor9rkqLszGIU4o_Mo0Yfak2Ck-lJa6EbPnRVRUirI-lD-FkGBYj',
    category: 'Retail'
  },
  {
    id: 'rum-tribe-yumi-rum',
    title: '83 Islands Yumi Rum - Premium Australian Retail',
    publication: 'Rum Tribe',
    date: '2024',
    excerpt: 'Australian specialty rum retailer Rum Tribe features our Yumi rum, bringing the authentic taste of Vanuatu to Australian rum enthusiasts.',
    image: '/image/83islands_sugarcane.jpg',
    url: 'https://rumtribe.com.au/product/83-islands-yumi-rum/?srsltid=AfmBOoqbTLzlvLvAVIbvf3BgPGsP9PCg4iAUcp4iKkV77zCaD_vLtmrC',
    category: 'Retail'
  },
  {
    id: 'gotrum-exclusive-interview',
    title: 'Exclusive Interview with Pierre-Luc Chabot and Martin St-Hilaire',
    publication: 'GoRum',
    date: '2024',
    excerpt: 'In-depth interview with 83 Islands Distillery founders, exploring their vision for sustainable rum production and the unique terroir of Vanuatu.',
    image: '/image/83islands_location.jpg',
    url: 'https://www.gotrum.com/editorials/exclusive-interviews/exclusive-interview-with-Pierre-Luc-Chabot-and-Martin-St-Hilaire-83-Islands-Distillery/',
    category: 'Industry'
  },
  {
    id: 'reddit-rum-community',
    title: 'Rum Haul from Curiada with Tasting Thoughts',
    publication: 'Reddit r/rum Community',
    date: '2024',
    excerpt: 'Reddit rum enthusiasts share their tasting notes and experiences with 83 Islands rum, highlighting the quality and character of our spirits in the global rum community.',
    image: '/image/83islands_shop.jpg',
    url: 'https://www.reddit.com/r/rum/comments/1kmp3t6/rum_haul_from_curiada_with_tasting_thoughts/',
    category: 'Community'
  },
  {
    id: '88bamboo-dead-reckoning',
    title: 'Australian Indie Rum Bottler Dead Reckoning Bottles Vanuatu First',
    publication: '88 Bamboo',
    date: '2024',
    excerpt: 'Australian independent rum bottler Dead Reckoning partners with 83 Islands Distillery to create unique expressions, representing Vanuatu\'s first premium rum bottling.',
    image: '/image/83islands_location.jpg',
    url: 'https://88bamboo.co/blogs/news/australian-indie-rum-bottler-dead-reckoning-bottles-vanuatu-first-representing-83-islands-rum?srsltid=AfmBOoptbbJUdSNDcmdfWck0_pum3JaJBY7AyMHbZM96qNuSXLCrnvQB',
    category: 'Industry'
  },
  {
    id: 'nicks-wine-merchants',
    title: '83 Islands Single Blend Yumi Vanuatu Rum 750ml',
    publication: 'Nick\'s Wine Merchants',
    date: '2024',
    excerpt: 'Premium Australian wine and spirits retailer Nick\'s features our Yumi rum, bringing the authentic taste of Vanuatu to discerning Australian consumers.',
    image: '/image/83islands_sugarcane.jpg',
    url: 'https://www.nicks.com.au/products/83-islands-single-blend-yumi-vanuatu-rum-750ml?srsltid=AfmBOooAsttMh_6MirmJE7YJ-47BzmtoqaS3ahITQzmtHDYV6n8lgZ8G',
    category: 'Retail'
  },
  {
    id: 'malthaven-dead-reckoning',
    title: 'Dead Reckoning 83 Islands Vanuatu Rum FRS',
    publication: 'Malthaven',
    date: '2024',
    excerpt: 'Specialty spirits retailer Malthaven showcases our Dead Reckoning collaboration, highlighting the unique character and quality of Vanuatu rum.',
    image: '/image/83islands_location.jpg',
    url: 'https://www.malthaven.com/product/dead-reckoning-83-islands-vanuatu-rum-frs/',
    category: 'Retail'
  },
  {
    id: 'abroad-guide-tours',
    title: '83 Islands Distillery Sightseeing of Port Vila with Yumi Tours',
    publication: 'The Abroad Guide',
    date: '2024',
    excerpt: 'Travel guide featuring 83 Islands Distillery as a must-visit destination in Port Vila, highlighting our distillery tours and the authentic Vanuatu experience we offer.',
    image: '/image/83islands_location.jpg',
    url: 'https://theabroadguide.com/83-islands-distillery-sightseeing-of-port-vila-with-yumi-tours/',
    category: 'Travel'
  }
]

// Categories for filtering
export const newsCategories = [
  'All',
  'Press Release',
  'Travel',
  'Awards',
  'Industry',
  'Retail',
  'Community'
]

// Function to get articles by category
export const getArticlesByCategory = (category) => {
  if (category === 'All') {
    return newsArticles
  }
  return newsArticles.filter(article => article.category === category)
}

// Function to get latest articles
export const getLatestArticles = (limit = 6) => {
  return newsArticles.slice(0, limit)
}

// Function to search articles
export const searchArticles = (query) => {
  const lowercaseQuery = query.toLowerCase()
  return newsArticles.filter(article => 
    article.title.toLowerCase().includes(lowercaseQuery) ||
    article.publication.toLowerCase().includes(lowercaseQuery) ||
    article.excerpt.toLowerCase().includes(lowercaseQuery)
  )
}
